(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealObserver = !reducedMotion && 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px' })
      : null;

    const initReveals = (scope = document) => {
      scope.querySelectorAll('[data-delay]').forEach((element) => {
        element.style.setProperty('--delay', `${element.dataset.delay}ms`);
      });
      scope.querySelectorAll('.reveal').forEach((element) => {
        if (revealObserver) revealObserver.observe(element);
        else element.classList.add('is-visible');
      });
    };

    const initHeader = (scope = document) => {
      const header = scope.querySelector('[data-header]');
      const menuButton = scope.querySelector('[data-menu-toggle]');
      const mobileMenu = scope.querySelector('[data-mobile-menu]');
      if (!header || !menuButton || !mobileMenu || menuButton.dataset.hhBound === 'true') return;

      menuButton.dataset.hhBound = 'true';
      let lastFocused = null;
      const setMenu = (open) => {
        mobileMenu.classList.toggle('is-open', open);
        mobileMenu.setAttribute('aria-hidden', String(!open));
        menuButton.setAttribute('aria-expanded', String(open));
        menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        document.body.classList.toggle('menu-open', open);
        if (open) {
          lastFocused = document.activeElement;
          mobileMenu.querySelector('a')?.focus();
        } else if (lastFocused instanceof HTMLElement) {
          lastFocused.focus();
        }
      };

      const updateHeader = () => {
        if (header.isConnected) header.classList.toggle('is-stuck', window.scrollY > 80);
      };
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
      menuButton.addEventListener('click', () => setMenu(menuButton.getAttribute('aria-expanded') !== 'true'));
      mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menuButton.isConnected && menuButton.getAttribute('aria-expanded') === 'true') setMenu(false);
      });
    };

    const initQuickForms = (scope = document) => {
      scope.querySelectorAll('.hh-quick-form [data-variant-select]').forEach((select) => {
        if (select.dataset.hhBound === 'true') return;
        select.dataset.hhBound = 'true';
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          const form = select.closest('form');
          const buyPanel = select.closest('.hh-buy');
          const price = buyPanel?.querySelector('[data-selected-price]');
          const button = form?.querySelector('[type="submit"]');
          if (price && option.dataset.price) price.textContent = option.dataset.price;
          if (button) {
            button.disabled = option.dataset.available !== 'true';
            button.querySelector('[data-button-label]')?.replaceChildren(
              document.createTextNode(option.dataset.available === 'true' ? 'Add to cart' : 'Sold out')
            );
          }
        });
      });
    };

    initHeader();
    initReveals();
    initQuickForms();

    if (!reducedMotion) {
      window.addEventListener('pointermove', (event) => {
        const product = document.querySelector('[data-parallax-product]');
        if (!product || window.innerWidth < 900) return;
        const x = (event.clientX / window.innerWidth - 0.5) * 7;
        const y = (event.clientY / window.innerHeight - 0.5) * 5;
        product.style.translate = `${x}px ${y}px`;
      }, { passive: true });
    }

    document.addEventListener('shopify:section:load', (event) => {
      initHeader(event.target);
      initReveals(event.target);
      initQuickForms(event.target);
    });
  });
})();
